import type { ReactNode } from 'react';

export const symbol_landscape_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M191-449q7.87-15 22.44-24 14.56-9 31.48-9 17.65 0 32.37 10Q292-462 300-445l37 88q6 13 21.31 11.93Q373.63-346.14 378-359l89-298q14-45 52-73t85.47-28q46.53 0 84.03 27t52.5 72l160 459q5 14-3.5 27t-24.79 13q-9.31 0-17.07-5.56-7.76-5.55-11.64-14.44L684-640q-9-26-31-42t-49-16q-27 0-49 16t-30 42l-89 298q-8 26-30 42t-49.37 16q-24.63 0-45.13-13.5Q291-311 282-334l-39-92-123 249q-3.64 7.73-10.93 12.36-7.29 4.64-15.31 4.64Q77-160 68-174.5T67-203l124-246Zm41.5-125q-46.5 0-79.5-33t-33-80q0-46 32.96-79.5T233-800q46 0 79.5 33.5T346-687q0 47-33.5 80t-80 33Zm.5-60q22 0 37.5-15.13t15.5-37.5q0-22.37-15.5-37.87Q255-740 233-740t-37.5 15.33q-15.5 15.34-15.5 38Q180-664 195.5-649t37.5 15Zm124 350ZM233-687Z"
		/>
	</svg>
);
